import React, { useRef } from 'react';
import { tw, css } from 'twind/style';

import { useSharedRef } from 'hooks/useSharedRef';

const Toggle = (props, forwardedRef) => {
  const { id, disabled, className, ...rest } = props;

  const inputRef = useRef<HTMLInputElement>(null);
  const ref = useSharedRef(forwardedRef, inputRef);

  return (
    <label
      data-disabled={disabled}
      htmlFor={id}
      className={tw([
        `relative flex items-center min-h-6 cursor-pointer`,
        css`
          & > input:checked + [data-type='check-btn'] {
            @apply bg-puma-gold bg-opacity-40;
            & > span {
              @apply bg-puma-gold translate-x-full opacity-100 duration-200;
            }
          }
        `,
        className,
      ])}
    >
      <input
        id={id}
        type="checkbox"
        ref={ref}
        disabled={disabled}
        className="hidden"
        {...rest}
      />
      <div
        aria-hidden={true}
        data-type="check-btn"
        className="h-2.5 w-10 rounded-full bg-opacity-30 bg-gray-300"
      >
        <span className="absolute top-1/2 -translate-y-1/2 w-5 h-5 rounded-2xl bg-puma-gold cursor-pointer bg-gray-400 opacity-70 duration-150" />
      </div>
    </label>
  );
};

export type InputToggleProps = React.ComponentProps<'input'>;

export const ToggleSwitch = React.forwardRef<any, InputToggleProps>(Toggle);
